import { useCallback } from 'react';
import { type ReactNode } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { Slide } from 'react-toastify';

export const useToast = () => {
	const showToast = useCallback((message: ReactNode, type: 'success' | 'error' | 'warning') => {
		const baseClass = 'rounded-xl py-4 px-6 w-full whitespace-pre-line text-center';
		const colorClass =
			type === 'success'
				? 'bg-success text-white'
				: type === 'error'
					? 'bg-error text-white'
					: 'bg-warning text-white';

		const options: ToastOptions = {
			position: 'top-center',
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			transition: Slide,
			className: `${baseClass} ${colorClass}`,
			icon: false,
		};

		if (type === 'success') {
			toast.success(message, options);
		} else {
			toast.error(message, options);
		}
	}, []);

	return { showToast };
};
